import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { st, classes } from './CoreDropdownOption.st.css';
export const CoreDropdownOption = props => {
  const {
    id,
    option,
    isSelected,
    isHovered,
    role,
    onClickHandler,
    onMouseEnterHandler,
    onMouseLeaveHandler,
    dataHook
  } = props;
  const disabled = option.isDisabled;
  const selectable = option.isSelectable;
  const hovered = !disabled && isHovered;
  const selected = !disabled && isSelected;
  const ariaProps = selectable ? {
    role,
    'aria-selected': selected,
    'aria-disabled': disabled
  } : {};
  return /*#__PURE__*/React.createElement("div", _extends({
    id: id,
    tabIndex: -1,
    className: st(classes.root, {
      disabled,
      selectable,
      hovered,
      selected
    }, props.className),
    "data-hook": dataHook
  }, ariaProps, {
    onClick: onClickHandler,
    title: option.value,
    onMouseEnter: onMouseEnterHandler,
    onMouseLeave: onMouseLeaveHandler
  }), option.render(option.value));
};
CoreDropdownOption.displayName = 'CoreDropdownOption';
//# sourceMappingURL=CoreDropdownOption.js.map